<template>
  <div>
    <v-form ref="form" v-model="formValid">
      <v-text-field
        name="shopId"
        label="Shop ID *"
        v-model="formData.channelShopID"
        :rules="formRules.required"
        outlined
        required
      ></v-text-field>

      <v-text-field
        name="livePartnerId"
        label="Live Partner ID *"
        v-model="formData.channelPartnerID"
        :rules="formRules.required"
        outlined
        required
      ></v-text-field>

      <v-text-field
        name="liveKey"
        label="Live Key *"
        v-model="formData.channelKey"
        :rules="formRules.channelKey"
        :placeholder="
          !formData.channelKey && !formData.channelKeyEncrypted
            ? ''
            : '**********************************************'
        "
        outlined
        required
      ></v-text-field>

      <div class="tw-flex tw-flex-wrap tw-gap-x-8">
        <v-menu
          v-model="startDatePickerMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="formData.dateStartSyncSaleOrders"
              :rules="formRules.required"
              label="วันที่เริ่มดึงข้อมูล *"
              append-icon="mdi-chevron-down"
              readonly
              outlined
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="formData.dateStartSyncSaleOrders"
            @input="startDatePickerMenu = false"
          ></v-date-picker>
        </v-menu>
        <v-menu
          ref="startTimePickerMenu"
          v-model="startTimePickerMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="formData.timeStartSyncSaleOrders"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="formData.timeStartSyncSaleOrders"
              :rules="formRules.required"
              label="เวลาที่เริ่มดึงข้อมูล *"
              append-icon="mdi-chevron-down"
              readonly
              outlined
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="startTimePickerMenu"
            v-model="formData.timeStartSyncSaleOrders"
            full-width
            format="24hr"
            @click:minute="onSelectStartTimeMinute"
          ></v-time-picker>
        </v-menu>
      </div>

      <copy-text-field
        name="liveCallbackUrl"
        label="Live Callback URL"
        v-model="liveCallbackUrl"
      />

      <v-text-field
        name="channelName"
        label="ชื่อช่องทางการเชื่อมต่อ (ภาษาไทย)*"
        v-model="formData.nameTH"
        :rules="formRules.required"
        outlined
        required
      ></v-text-field>

      <v-text-field
        name="channelName"
        label="ชื่อช่องทางการเชื่อมต่อ (ภาษาอังกฤษ)*"
        v-model="formData.nameEN"
        :rules="formRules.required"
        outlined
        required
      ></v-text-field>

      <div
        class="tw-mb-16 tw-mt-4 tw-flex tw-items-stretch tw-gap-4 tw-flex-wrap"
      >
        <v-btn
          class="tw-flex-auto"
          color="primary"
          href="https://seller.shopee.co.th/portal/partner-platform/shop"
          target="_blank"
          outlined
        >
          ตรวจสอบสถานะร้านค้ากับแอป
        </v-btn>
        <v-btn
          class="tw-flex-auto"
          color="primary"
          @click="connectShopee"
          outlined
        >
          เชื่อมต่อร้านค้ากับแอป (ทำประจำก่อน 1 ปี)
        </v-btn>
      </div>

      <div class="tw-flex tw-justify-between tw-my-2">
        <v-btn color="error" outlined @click="$emit('delete')">
          <img class="tw-mr-2" src="/images/icons/delete.svg" />
          ลบช่องทางการเชื่อมต่อ
        </v-btn>
        <v-btn
          class="tw-text-lg"
          color="primary"
          :disabled="loading"
          :loading="loading"
          @click="onSave"
          >บันทึก
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import CopyTextField from "../../../form/copy-text-field.vue";
import _ from "lodash";
import datetimeConverter from "../../../../../libs/datetimeConverter";
import rsa from "../../../../../libs/rsa";
import fc from "@/firebaseConfig";
import firebase from "firebase/app";

const DEFAULT_FORM = {
  channelType: 1,
  channelShopID: "",
  channelPartnerID: "",
  channelKey: "",
  channelKeyEncrypted: "",
  nameEN: "",
  nameTH: "",
  dateStartSyncSaleOrders: null,
  timeStartSyncSaleOrders: null
};

export default {
  name: "ShopChannelFormShopee",
  components: {
    CopyTextField
  },
  props: {
    companyId: {
      type: String,
      required: true
    },
    shopId: {
      type: String,
      required: true
    }
  },
  data: () => ({
    loading: false,
    formData: { ...DEFAULT_FORM },
    formValid: false,
    startDatePickerMenu: false,
    startTimePickerMenu: false,
    unsubscribeInfosAuth: null,
    authInfo: null
  }),
  computed: {
    formRules() {
      return {
        required: [v => !!v],
        channelKey: [v => !!v || !!this.formData.channelKeyEncrypted]
      };
    },
    /** @return {string} */
    liveCallbackUrl() {
      if (!this.formData.id) {
        return "";
      }
      return `https://phasicharoen.com/pushSaleOrders/${this.companyId}/${this.shopId}/${this.formData.id}`;
    }
    /** @return {string} */
    // tempAuthPartnerURL() {
    //   if (!this.formData.channelKey || !this.formData.channelPartnerID) {
    //     return ''
    //   }
    //   const mHostURL = 'https://phasicharoen.com'
    //   const keyURL = this.formData.channelKey + mHostURL
    //   const token = sha256(keyURL)
    //   const url = `https://partner.shopeemobile.com/api/v1/shop/auth_partner?id=${this.formData.channelPartnerID}&token=${token}&redirect=${mHostURL}`
    //   return url
    // },
    /** @return {string} */
    // displayAuthPartnerURL() {
    //   if (this.authInfo && this.authInfo.authPartnerURL) {
    //     return this.authInfo.authPartnerURL
    //   }
    //   return this.tempAuthPartnerURL
    // }
  },
  beforeDestroy() {
    if (this.unsubscribeInfosAuth) {
      this.unsubscribeInfosAuth();
    }
  },
  created() {
    // this.checkCode();
  },
  methods: {
    async connectShopee() {
      const companyID = this.companyId;
      const shopID = this.shopId;
      const channelID = this.formData.id;
      const redirectURL = `${location.protocol}//${location.host}/${companyID}/settings/shops/${shopID}/channels/${channelID}`;
      const getOAuthURL = firebase.functions().httpsCallable("getOAuthURL");
      const data = {
        channelPartnerID: this.formData.channelPartnerID,
        channelKeyEncrypted: this.formData.channelKeyEncrypted,
        redirectURL: redirectURL
      };
      const k = await getOAuthURL(data);
      window.open(k.data.url);
    },
    async checkCode() {
      const code = this.$route.query.code;
      if (!code) {
        return;
      }

      let data = {
        chCode: code
      };
      const ref = fc.db.doc(
        `/Companies/${this.companyId}/Shops/${this.shopId}/Channels/${this.formData.id}`
      );
      await ref.set(data, { merge: true });
    },
    setData(data) {
      // clone form data
      let newData = _.cloneDeep(data);

      // split date and time
      if (newData.timeStartSyncSaleOrders) {
        const dt = datetimeConverter.convertFirebaseTimestampToDateAndTime(
          newData.timeStartSyncSaleOrders
        );
        newData.dateStartSyncSaleOrders = dt.date;
        newData.timeStartSyncSaleOrders = dt.time;
      }

      this.formData = newData;
      this.authInfo = null;
      this.$refs.form.resetValidation();

      // unsubscribe old auth info
      if (this.unsubscribeInfosAuth) {
        this.unsubscribeInfosAuth();
      }

      // subscribe auth info
      if (this.formData.id) {
        this.unsubscribeInfosAuth = fc.companies
          .doc(this.companyId)
          .collection("Shops")
          .doc(this.shopId)
          .collection("Channels")
          .doc(this.formData.id)
          .collection("Infos")
          .doc("auth")
          .onSnapshot(doc => {
            if (doc.exists) {
              this.authInfo = doc.data();
            }
          });
      }

      this.checkCode();
    },
    onSelectStartTimeMinute() {
      this.$refs.startTimePickerMenu.save(
        this.formData.timeStartSyncSaleOrders
      );
    },
    async onSave() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.loading = true;
      const data = { ...this.formData };

      // convert sync datetime to firebase comaptible and set to timeStartSyncSaleOrders
      if (data.dateStartSyncSaleOrders) {
        data.timeStartSyncSaleOrders = datetimeConverter.convertDateAndTimeToFirebaseTimestamp(
          data.dateStartSyncSaleOrders,
          data.timeStartSyncSaleOrders
        );
      }
      delete data.dateStartSyncSaleOrders;

      // encrypt channel key
      if (data.channelKey) {
        data.channelKeyEncrypted = rsa.encrypt(data.channelKey);
      }

      // delete unencrypted fields before save
      delete data.channelKey;

      await this.$store.dispatch("shopChannels/save", {
        companyId: this.companyId,
        shopId: this.shopId,
        channel: data
      });
      this.loading = false;
      this.$emit("save");
    }
  }
};
</script>
